import { render } from "./CookIcon.vue?vue&type=template&id=40b8746f"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/CookIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40b8746f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40b8746f', __exports__)) {
    api.reload('40b8746f', __exports__)
  }
  
  module.hot.accept("./CookIcon.vue?vue&type=template&id=40b8746f", () => {
    api.rerender('40b8746f', render)
  })

}


export default __exports__